/**
 * Who is there.
 *
 * One function, because the answer used to be spread over a try and a catch
 * in the auth context and came out the same either way: a made-up "Local
 * User". That is right on a Mac running its own copy of Novamund and wrong
 * everywhere else, and being wrong about it does not look like an error. It
 * looks like an app that works, until every call it makes comes back 401.
 *
 * The order below is the whole point:
 *
 *   1. A token is a session. It was issued by a backend that checked
 *      something, and pairing issues one to a phone.
 *   2. Coming in over the tunnel is never a local session. The Mac at the
 *      other end honestly answers that it is one person's machine; that is a
 *      statement about the Mac, not about the phone holding the other end of
 *      the wire.
 *   3. Only then may a backend's own word count. No answer is not permission.
 */

/** A real session, checked by a backend. */
export const TOKEN = "token";
/** One person's own machine, where signing in would be asking yourself. */
export const LOCAL = "local";
/** Nobody. The screen to show is the one that lets someone become somebody. */
export const NOBODY = "nobody";

export function whoIsSignedIn({ hasToken = false, tunnelLive = false, backend = null } = {}) {
  if (hasToken) return TOKEN;
  if (tunnelLive) return NOBODY;
  if (backend && backend.single_user === true) return LOCAL;
  return NOBODY;
}
